var _excluded = ["size", "color", "onClick", "cursor", "display", "data-test-name", "aria-label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react"; // DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using iconTemplate.js Please refer to web/src/nessie/icons/README.md for more details

import { nessiePropCheckerWrapper } from "../../nessiePropCheckerWrapper";
import { colorNessieResponsivePropType, oneOfNessieResponsivePropType } from "../../propTypes";
import UnstyledButton from "../../../../components/buttons/UnstyledButton";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";

var PeopleIcon = function PeopleIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? "m" : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "shale" : _ref$color,
      onClick = _ref.onClick,
      cursor = _ref.cursor,
      _ref$display = _ref.display,
      display = _ref$display === void 0 ? "inline-block" : _ref$display,
      dataTestName = _ref["data-test-name"],
      ariaLabel = _ref["aria-label"],
      props = _objectWithoutProperties(_ref, _excluded);

  var sizeInPixels = SIZES[size];
  var ButtonOrSpan = onClick ? UnstyledButton : "span";
  return _jsx(ButtonOrSpan, {
    "aria-label": ariaLabel,
    "data-test-name": dataTestName,
    onClick: onClick,
    sx: {
      fontSize: sizeInPixels,
      display: display,
      lineHeight: 0,
      color: color,
      cursor: cursor,
      position: "relative"
    },
    children: _jsx("svg", _objectSpread(_objectSpread({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {}, {
      children: _jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.2 3.2a3.262 3.262 0 00-2.684 1.399 5.537 5.537 0 012.101 5.617l-.082.39c-.129.623-.292 1.409-.537 2.127-.198.584-.48 1.225-.914 1.817.308.115.676.236 1.104.375l.062.02c.61.199 1.359.442 1.962.73.42.199.795.481 1.103.825h2.715a1.47 1.47 0 00.63-2.8c-.435-.207-1.009-.393-1.583-.58-1.134-.37-2.273-.74-2.359-1.268v-.539c0-.155.004-.341.123-.437.945-.761 1.223-2.095 1.476-3.312l.084-.396A3.275 3.275 0 0016.2 3.2zM6.542 9.835a3.743 3.743 0 117.316 0l-.095.452c-.29 1.391-.608 2.916-1.688 3.786-.136.11-.14.321-.14.5v.615c.098.604 1.4 1.027 2.695 1.449.657.213 1.313.427 1.81.663a1.683 1.683 0 01-.72 3.2H4.68a1.68 1.68 0 01-.72-3.2c.487-.231 1.125-.442 1.765-.653 1.287-.424 2.583-.852 2.682-1.459v-.639c0-.192-.02-.412-.164-.536-1.012-.878-1.323-2.367-1.605-3.722l-.096-.456z"
      })
    }))
  });
};

var SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px"
};
PeopleIcon.nessiePropTypes = {
  color: colorNessieResponsivePropType,
  size: oneOfNessieResponsivePropType(["xs", "s", "m", "l", "xl", "xxl"])
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  PeopleIcon = nessiePropCheckerWrapper(PeopleIcon);
}

export default PeopleIcon;
//# sourceMappingURL=PeopleIcon.js.map